import React from "react";

import Tooltip from "@mui/material/Tooltip";
import MuiButton, { ButtonProps } from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import { SvgIconProps } from "@mui/material/SvgIcon";

interface IconButtonProps extends ButtonProps {
  icon?: React.ReactElement<SvgIconProps>;
  iconSize?: "small" | "medium" | "large";
}

const Button: React.FC<IconButtonProps> = ({
  onClick,
  children,
  title = "",
  size,
  type = "button",
  disabled = false,
  icon,
  iconSize = "small",
  ...rest
}) => {
  const buttonElement = icon ? (
    <IconButton disabled={disabled} size="small" onClick={onClick} className="m-btn">
      {React.cloneElement(icon, { fontSize: iconSize })}
    </IconButton>
  ) : (
    <MuiButton
      variant="outlined"
      style={{
        height: size ? "initial" : "2.5rem",
        marginRight: "1rem",
        width: "max-content",
      }}
      size={size}
      onClick={onClick}
      type={type}
      disabled={disabled}
      {...rest}
    >
      {children}
    </MuiButton>
  );

  // Wrap disabled buttons in a span to allow tooltips to work
  const wrappedButton = disabled ? <span>{buttonElement}</span> : buttonElement;

  return (
    <Tooltip
      title={title}
      slotProps={{
        popper: {
          sx: {
            zIndex: 2002,
          },
        },
      }}
    >
      {wrappedButton}
    </Tooltip>
  );
};

export default Button;
